<template>

    <SubHeading :home="home" :tabs="tabs" :shorts="false" :currTab="currTab" @active="handleActive" />

    <!-- search layer -->
    <!-- <div class="grey lighten-4">
        <div class="container section"></div>
    </div> -->

    <!-- breadcrumbs -->
  <nav class="grey lighten-4 z-depth-0">
    <div class="container nav-wrapper">
      <div class="col s12">
        <router-link to="/" class="breadcrumb teal-text"><small> <i class="material-icons left">home</i> Dashboard</small></router-link>
        <span class="breadcrumb blue-grey-text pointable"><small>Medical History Home</small></span>
      </div>
    </div>
  </nav>

    <!-- Top -->
    <div id="top"></div>

    <div class="container">

        <LoadingDiv v-if="!isReady" />

        <div v-else>
            <br />

            <PaginationDiv :payLoad="allPages" @newPage="handlePage" v-if="claims.length" />

            <div class="section">
                <!-- Auth -->
                <div class="card z-depth-0">
                    <div class="card-content grey lighten-5" v-for="claim in claims" :key="claim.id">
                        <div class="row">
                            <div class="col s3">
                                <h6>
                                    {{ claim.encounter.name }}
                                    <br />
                                    <small>{{ claim.encounter.enrollee_number }}</small>
                                    <br />
                                    <small>({{ claim.encounter.client_name }})</small>
                                </h6>
                            </div>
                            <div class="col s2">
                                <p>{{ claim.encounter.provider.name }}</p>
                            </div>
                            <div class="col s2">
                                <p>
                                    <b>{{ claim.encounter.diagnosis }}</b>
                                </p>
                            </div>
                            <div class="col s2">
                                <p>
                                    {{ claim.item }}
                                    <span class="black-text">(x<b>{{ claim.sent_qty }}</b>)</span>
                                </p>
                            </div>
                            <div class="col s2">
                                <p>
                                    <span v-if="claim.authorization === 'z'">
                                        <span class="chip" v-if="claim.status === 'a'">Pending</span>
                                        <span class="chip red lighten-2" v-else>Declined</span>
                                    </span>

                                    <span v-else>{{ claim.authorization_code }}<br />
                                        <span class="chip green lighten-2" v-if="claim.approved_price">
                                            <b>Approved</b>
                                        </span>
                                    </span>
                                </p>
                            </div>
                            <div class="col s1">
                                <p class="right" :class="{
                                    'black-text': claim.authorization === 'z',
                                    'green-text': claim.authorization !== 'z',
                                }">
                                    {{
                                        new Date(claim.created_at).toLocaleString(undefined, {
                                            year: "numeric",
                                            month: "short",
                                            day: "numeric",
                                        })
                                    }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <br />
                </div>
            </div>
            <!-- No Auth Found -->
            <div class="section center" v-if="!claims.length && !isLoading">
                <h6 class="chip">No Previous Authorization <em>found</em>...</h6>
            </div>


            <PaginationDiv :payLoad="allPages" @newPage="handlePage" v-else />
        </div>
    </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { ageSex } from "@/composables/fxLibrary/coreFx";
import getItems from "@/composables/getItems";
import SubHeading from "@/components/HeaderSubDiv.vue";
import LoadingDiv from "@/components/LoadingDiv.vue";
import PaginationDiv from "@/components/pager/PaginationDiv.vue";

export default {
    name: "HistoryAuthComponent",
    components: { SubHeading, LoadingDiv, PaginationDiv },
    setup() {
        const response = ref(null);
        const error = ref(false);
        const isReady = ref(false);
        const isLoading = ref(true);
        const home = ref(null);
        const currTab = ref(null);
        const tabs = ref([]);

        // vue router
        const router = useRouter();

        // store
        const store = useStore();

        // default enrollee number for testing
        const enrolleeNumber = store.state?.user?.account?.enrollee_number;

        // start
        onMounted(() => {
            // page name
            document.title = "Medical History";
        });

        // menu
        onMounted(() => {
            // load tab
            tabs.value.push({ id: 1, name: "Medical History", title: "Home", icon: null, url: "history", hash: null, });

            // set default
            currTab.value = tabs.value.find(x => x.title.includes("Home"));
            // set home
            home.value = tabs.value.find(x => x.title.includes("Home"));
        });

        // starter
        onMounted(() => {
            // get items from function
            getItemsFromApi(`claim/auth/enrollee?e=${enrolleeNumber}`);
        });

        // handle curr status
        const handleActive = (tab) => {
            // refer
            if (tab.hash) {
                router.push({ name: tab.url, hash: tab.hash });
            } else {
                router.push({ name: tab.url });
            }
        };

        // get function
        const getItemsFromApi = (table) => {
            (async () => {
                const { res, err } = await getItems(table);

                if (res.value) {
                    response.value = res.value.data;

                } else {
                    error.value = err.value;
                }

                // Ready, Loading is complete
                isReady.value = true;
                isLoading.value = false;
            })();
        };

        // numbering
        const numberBadge = (num) => {
            return (
                (allPages.value.current_page - 1) * allPages.value.per_page + num + 1
            );
        };

        // ageSex
        const showAgeSex = (dob, sex) => {
            const { fx } = ageSex(dob, sex);
            return fx.value;
        };

        // switch page
        const handlePage = (page) => {
            // start laoding
            isReady.value = false;
            // go back up
            router.push({ hash: "#top" });
            // get new page items from function
            getItemsFromApi(
                `claim/auth/enrollee?e=${enrolleeNumber}&page=${page}`
            );
        };

        // output results
        const claims = computed(() => {
            if (!response.value) {
                return [];
            } else {
                return response.value.data;
            }
        });

        // output pages
        const allPages = computed(() => {
            if (!response.value) {
                return [];
            } else {
                return response.value; // get all
            }
        });

        return {
            handleActive,
            handlePage,
            showAgeSex,
            numberBadge,
            home,
            currTab,
            tabs,
            error,
            isReady,
            isLoading,
            claims,
            allPages,
        };
    },
};
</script>

<style scoped>
.progress {
    margin-top: -15px;
    /* Adjust the value as needed to move the progress bar upwards */
}
</style>
